<template>
    <div class="child-tracking-system">
        <child-tracking-system-default v-if="getApplicationSetting('child_tracking_system') === '1'"/>
    </div>
</template>

<script>
    import ChildTrackingSystemDefault from '@/views/childtrackingsystem/Default'

    export default {
        name: 'child-tracking-system',
        components: {
            ChildTrackingSystemDefault
        }
    }
</script>

<style scoped>
</style>